<template>
    <div
            class="image-loader"
            v-bind:class="{'loaded-origin': loaded, 'loaded-placeholder': placeholderLoaded}"
            v-observe-visibility="{
            callback: visibilityChanged,
            once: true,
        }">
        <img v-if="placeholder" @load="onPlaceholderLoaded" class="placeholder" :src="placeholder" />
<!--        <img v-if="lazyLoadVisible" @load="onOriginImageLoaded" class="origin" :src="src" :srcset="srcSet" />-->
        <picture v-if="lazyLoadVisible">
            <source :srcset="srcWebp" type="image/webp">
            <source :srcset="src" type="image/png">
            <img @load="onOriginImageLoaded" :src="src">
        </picture>
    </div>
</template>

<script>
    export default {
        props: {
            src: String,
            srcWebp: String,
            srcSet: String,
            placeholder: String
        },

        data(){
            return {
                loaded: false,
                placeholderLoaded: false,
                lazyLoadVisible: false
            }
        },

        methods: {
            visibilityChanged (isVisible, entry) {
                if(isVisible){
                    this.lazyLoadVisible = true;
                }
            },

            onOriginImageLoaded(){
                setTimeout(() => {
                    this.loaded = true;
                }, 10);
            },

            onPlaceholderLoaded(){
                this.placeholderLoaded = true;
            }
        },

        mounted() {
            if(!this.placeholder || this.placeholder === "") this.placeholderLoaded = true;
        },

        // updated() {
        //     this.$refs.picture.addEventListener('onload', this.onOriginImageLoaded());
        // }
    }
</script>

<style scoped lang="scss">
    .image-loader{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        transition: opacity 0.5s;
        overflow: hidden;

        picture,
        img{
            height: 100%;
            width: 100%;
            object-fit: cover;
            object-position: center;
            position: absolute;
            top: 0;
            left: 0;
        }

        picture{
            z-index: 1;
            opacity: 0;
            transition: all 0.75s;
        }

        img.placeholder{
            z-index: 1;
            transform: scale(1.02);
        }
        &.loaded-placeholder{
            opacity: 1;
        }
        &.loaded-origin{
            picture{
                opacity: 1;
            }
        }
    }
</style>
